import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  field: {
    '& .MuiFormLabel-root, &.MuiInputBase-root, & .MuiInputLabel-formControl, & .MuiInputBase-formControl, & .MuiTypography-body1': {
      fontSize: '14px',
    },
  },
}));